import { Controller } from "@hotwired/stimulus";

/** Adds/removes rows in schema-backed PMS array fields without exposing JSON. */
export default class extends Controller<HTMLElement> {
    static targets = ["rows", "template", "count"];
    static values = { nextIndex: Number };

    declare readonly rowsTarget: HTMLElement;
    declare readonly templateTarget: HTMLTemplateElement;
    declare readonly countTarget: HTMLInputElement;
    declare nextIndexValue: number;

    add(): void {
        const index = this.nextIndexValue;
        const template = document.createElement("template");
        template.innerHTML = this.templateTarget.innerHTML.split("__INDEX__").join(String(index)).trim();
        this.rowsTarget.append(template.content.cloneNode(true));
        this.nextIndexValue = index + 1;
        this.countTarget.value = String(this.nextIndexValue);
    }

    remove(event: Event): void {
        const button = event.currentTarget;
        if (!(button instanceof HTMLElement)) return;

        const row = button.closest<HTMLElement>("[data-pms-collection-target='row']");
        if (!row) return;

        row.querySelectorAll<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>("input, select, textarea").forEach((control) => {
            control.disabled = true;
        });
        row.hidden = true;
    }
}
